<template>
  <div>
    <div class="w-full flex items-center mb-6">
      <img :src="`/images/yazio/icons/${icon}.svg`" alt="icon" class="mr-2" />
      <h2 class="yazio-color-purple yazio-text-height text-xl mr-2 font-bold flex-shrink-0">{{ title }}</h2>
      <div class="yazio-divider w-full h-px"></div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
  },
});
</script>

<style lang="scss" scoped>
.yazio-color-purple {
  color: #9686c9;
}
.yazio-text-height {
  line-height: 1.1875rem;
}
.yazio-divider {
  background-color: #e2e5ed;
}
</style>
